import { render, staticRenderFns } from "./WineclubList.vue?vue&type=template&id=08575d9a&scoped=true"
import script from "./WineclubList.vue?vue&type=script&lang=js"
export * from "./WineclubList.vue?vue&type=script&lang=js"
import style0 from "./WineclubList.vue?vue&type=style&index=0&id=08575d9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08575d9a",
  null
  
)

export default component.exports